import { render, staticRenderFns } from "./RuleManage.vue?vue&type=template&id=eb0767d4&"
import script from "./RuleManage.vue?vue&type=script&lang=js&"
export * from "./RuleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports